import styled from 'styled-components'

export const AmountFractionStyled = styled.div<{
  size?: 'normal' | 'small'
}>`
  white-space: nowrap;

  & * {
    font-weight: ${(props) => props.theme.fontWeights.normal};
    font-size: ${(props) =>
      props.size === 'normal'
        ? props.theme.typography.pxToRem(props.theme.fontSizes.body1)
        : props.theme.typography.pxToRem(props.theme.fontSizes.body2)};
    line-height: ${(props) =>
      props.size === 'normal'
        ? props.theme.typography.pxToRem(24)
        : props.theme.typography.pxToRem(16)};
  }
`
